<template>
	<div>
		<el-form :model="customer" :rules="rules" ref="addCustomerForm" label-width="100px" size="medium"  :status-icon="true" label-suffix=" : ">
			<el-form-item label="姓名/公司" prop="name" >
				<el-input v-model="customer.name" style="width: 550px;"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="phone" >
				<el-input v-model="customer.phone"  style="width: 550px;"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" prop="idcard">
				<el-input v-model="customer.idcard" placeholder="身份证号"  style="width: 550px;"></el-input>
			</el-form-item>
			<el-form-item label="Email" prop="email">
				<el-input v-model="customer.email" placeholder="请输入Email"  style="width: 550px;"></el-input>
			</el-form-item>
			<el-form-item label="地址" prop="address">
				<el-input v-model="customer.address" placeholder="请输入地址"  style="width: 550px;"></el-input>
			</el-form-item>
			<el-form-item label="性别" prop="sex">
				<el-radio v-model="customer.sex" :label="1">男<i class="el-icon-male" style="margin-left: 5px;font-weight: bold;"></i></el-radio>
				<el-radio v-model="customer.sex" :label="2">女<i class="el-icon-female" style="margin-left: 5px;font-weight: bold;"></i></el-radio>
				<el-radio v-model="customer.sex" :label="0">未知</el-radio>
			</el-form-item>
		</el-form>
		<div style="text-align: right;">
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";

    export default {
        name: "edit-customer-panel",
			data:function () {
				var validatorPhone = function (rule, phone, callback) {
					if(phone == null || phone == ""){
						callback();
					}else if(!(/^1[3456789]\d{9}$/.test(phone))){
						callback(new Error("手机号码填写有误!"));
					}else{
						callback();
					}
				};
				return {
					operating:false,
					rules: {
						name: [
							{ required: true, message: '请输入客户姓名', trigger: 'blur' },
						],
						phone: [
							{ validator:validatorPhone },
						],
						// sex: [
						// 	{ required: true, message: '请选择性别', trigger: 'blur' }
						// ],
						// idcard: [
						// 	{ required: true, message: '请输入身份证号', trigger: 'blur' },
						// 	{ min: 15, max: 18, message: '长度在 15 到 18 个字符', trigger: 'blur' }
						// ],
						email:[
							{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
						]
					},
				}
			},
			props:{
				customer:{}
			},
			methods:{
				submit(){
					this.$refs.addCustomerForm.validate((valid) => {
						if (valid) {
							this.operating = true;
							axios({
								method: 'post',
								url:config.host+'/backend/customer/update.json',
								data:this.customer
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '更新成功',
										type: 'success'
									});
									this.$emit('updatesuccess');
								}else{
									this.$alert(response.data.emsg, '更新失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '更新失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				}
			}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/customer/EditCustomerPanel.vue